var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth0 } from "@auth0/auth0-react";
import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import listService from "../../services/listService";
import { CsvUploader } from "./CsvUploader";
const ManualImportView = () => {
    const { user } = useAuth();
    const { getAccessTokenSilently } = useAuth0();
    // State for the disabled URL/JSON panels — restore alongside them. `loading` only ever
    // guarded those two buttons; the CSV uploader tracks its own progress.
    // const [loading, setLoading] = useState(false);
    // const [linkedInUrl, setLinkedInUrl] = useState("");
    // const [jsonData, setJsonData] = useState("");
    const [message, setMessage] = useState(null);
    const [lists, setLists] = useState([]);
    // Fetch user's lists for CSV import
    useEffect(() => {
        const fetchLists = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(user === null || user === void 0 ? void 0 : user._id))
                return;
            try {
                const authToken = yield getAccessTokenSilently();
                const { lists: userLists } = yield listService.getUserLists(user._id, authToken);
                setLists(userLists);
            }
            catch (error) {
                console.error("Failed to fetch lists:", error);
            }
        });
        fetchLists();
    }, [user, getAccessTokenSilently]);
    // DISABLED: neither of these ever imported anything. handleImportFromUrl regex-checked the
    // URL and reported "Profile URL saved" without saving; handleImportFromJson parsed the JSON
    // and told the user to call the API themselves. Kept for reference — if they come back they
    // need real persistence, not just validation. See docs/feature-disabling-audit.md.
    //   const handleImportFromUrl = async () => {
    //     if (!linkedInUrl.trim()) {
    //       setMessage({ type: "error", text: "Please enter a LinkedIn profile URL" });
    //       return;
    //     }
    //
    //     setLoading(true);
    //     setMessage(null);
    //
    //     try {
    //       // Extract LinkedIn ID from URL
    //       const match = linkedInUrl.match(/linkedin\.com\/in\/([^/?]+)/);
    //       if (!match) {
    //         throw new Error("Invalid LinkedIn URL format");
    //       }
    //
    //       setMessage({
    //         type: "success",
    //         text: "Profile URL saved. Note: You need the Chrome extension to fetch full profile data.",
    //       });
    //       setLinkedInUrl("");
    //     } catch (error) {
    //       setMessage({
    //         type: "error",
    //         text: error instanceof Error ? error.message : "Failed to import profile",
    //       });
    //     } finally {
    //       setLoading(false);
    //     }
    //   };
    //
    //   const handleImportFromJson = async () => {
    //     if (!jsonData.trim()) {
    //       setMessage({ type: "error", text: "Please paste JSON data" });
    //       return;
    //     }
    //
    //     setLoading(true);
    //     setMessage(null);
    //
    //     try {
    //       const data = JSON.parse(jsonData);
    //
    //       // Validate it's a candidate object
    //       if (!(data.linkedInId || data.publicIdentifier)) {
    //         throw new Error("Invalid candidate data: missing linkedInId or publicIdentifier");
    //       }
    //
    //       setMessage({
    //         type: "success",
    //         text: "JSON validated! Use the API endpoint shown below to import this candidate programmatically.",
    //       });
    //     } catch (error) {
    //       setMessage({
    //         type: "error",
    //         text: error instanceof Error ? error.message : "Invalid JSON format",
    //       });
    //     } finally {
    //       setLoading(false);
    //     }
    //   };
    return (_jsxs(Box, Object.assign({ sx: { p: 3 } }, { children: [message && (_jsx(Alert, Object.assign({ severity: message.type, sx: { mb: 3 }, onClose: () => setMessage(null) }, { children: message.text }))), _jsx(CsvUploader, { lists: lists })] })));
};
export default ManualImportView;
